import { SchoolAgentNetworkConfig } from "./src/SchoolAgentNetworkConfig"

export const config: SchoolAgentNetworkConfig = {
    enrollmentEndpoint: "https://schools-backend-beta.zaindari.com/api/v1/agents/chrome/enroll",
    WSEndpoint: "wss://chrome-beta.zaindari.com/api/v1/ws",
    enrollmentToken: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzY2hvb2xJZCI6ImU4ODgzZDY4LWM4NzQtNDlmMC04YTQ1LWQwM2FiMTBiYjk3ZiIsImlhdCI6MTc2MjM0MTI1OSwiZXhwIjoxODA1NTQxMjU5fQ.AD3he--r6oOV1x8Ecfw82-KtmRl7H5hNhOR3-b0fdac",
    controllerOrigin: "https://controller-dev.zaindari.com"
}